<template>
	<div class="notice">
		<ul :scroll="scroll" :style="{'transform': `translate(0,-${0.36 * index}rem)`}">
			<li v-for="(data, i) in dataList" :key="i" class="item flex">
				<div v-for="(item, j) in fieldList" :key="j" class="flex-center-cross" :style="{'flex-grow': item.width}">
					<slot v-if="$scopedSlots[item.code]" :name="item.code" :data="data"></slot>
					<span v-else>{{data[item.code]}}</span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fieldList: [],
				dataList: [],
				index: 0,
				scroll: false
			}
		},
		
		beforeDestroy() {
			clearTimeout(this._timer);
		},

		methods: {
			init(data) {
				this.fieldList = data.fieldList;
			},

			update(data) {
				clearTimeout(this._timer);
				this.index = 0;
				this.dataList = data;

				!function loop() {
					if (this.index >= this.dataList.length - 2) {
						this._timer = setTimeout(() => {
							this.$emit('update');
						}, 6000);
						return;
					}
					this._timer = setTimeout(() => {
						this.scroll = true;
						this.$nextTick(() => {
							this.index++;
						});
						setTimeout(() => {
							this.scroll = false;
						}, 500);
						loop.call(this);
					}, 6000);
				}.call(this)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.notice {
		height: 100%;
		margin: 0 -.2rem;
		overflow: hidden;

		ul {
			&[scroll] {
				transition: transform .5s ease;
			}
		}

		li {
			padding-left: .25rem;

			&:nth-child(even) {
				background: rgba(255,255,255,.1);
			}

			div {
				width: 0;
				height: .36rem;
				font-size: .13rem;
				color: #5DD2FF;

				&:nth-child(n+2) {
					margin-left: .03rem;
				}
			}
		}
	}
</style>
